<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("message.reportFeature") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">{{ $t("message.reporting") }}</div>
                <div class="feature-input">
                    <a-select v-model="featureForm.report" style="width: 100%">
                        <a-select-option value="basic-report">{{ $t("message.basicReporting") }}</a-select-option>
                        <a-select-option value="detail-report">{{ $t("message.detailReporting") }}</a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.visitorTracking">{{ $t("message.visitorReporting") }}</a-checkbox>
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.specialReport">{{ $t("message.customReporting") }}</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems } from "./index";

export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            report: null,
            visitorTracking: false,
            specialReport: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.REPORT);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.REPORT, ...this.featureForm };
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.REPORT);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
